import { Directive, Input, HostListener } from '@angular/core';

/*
    Returns error if email exists in db
*/

@Directive({
    selector: '[emailSuggestion]',
})


export class EmailSuggestionValidatorDirective {

    @Input()
    emailSuggestion: any;
    
    domainThreshold: any =2;
    secondLevelThreshold: any =2;
    topLevelThreshold: any =2;
    
    defaultSecondLevelDomains: any = ["yahoo", "hotmail", "mail", "live", "outlook", "gmx"]

    Domains: any = ['hotmail.com', 'gmail.com', 'outlook.com'];

    TopLevelDomains: any = ["com", "net", "org" ];

    constructor() {
    }

    @HostListener('focusout', ['$event.target'])
    onFocusout(target: any) {
        
        if (!this.emailSuggestion.errors) {
            var data = this.suggest(this.emailSuggestion.value, this.Domains, this.defaultSecondLevelDomains, this.TopLevelDomains, this.sift4Distance);
            if (data) {this.emailSuggestion.warnings = data.full;}
            else { this.emailSuggestion.warnings = undefined }
        }
      
    }

    splitEmail(email): any {
        email = email !== null ? (email.replace(/^\s*/, '').replace(/\s*$/, '')) : null; // trim() not exist in old IE!
        var parts = email.split('@');

        if (parts.length < 2) {
            return false;
        }

        for (var i = 0; i < parts.length; i++) {
            if (parts[i] === '') {
                return false;
            }
        }

        var domain = parts.pop();
        var domainParts = domain.split('.');
        var sld = '';
        var tld = '';

        if (domainParts.length === 0) {
            // The address does not have a top-level domain
            return false;
        } else if (domainParts.length == 1) {
            // The address has only a top-level domain (valid under RFC)
            tld = domainParts[0];
        } else {
            // The address has a domain and a top-level domain
            sld = domainParts[0];
            for (var j = 1; j < domainParts.length; j++) {
                tld += domainParts[j] + '.';
            }
            tld = tld.substring(0, tld.length - 1);
        }

        return {
            topLevelDomain: tld,
            secondLevelDomain: sld,
            domain: domain,
            address: parts.join('@')
        };
    }

    suggest(email, domains, secondLevelDomains, topLevelDomains, distanceFunction) : any{
        email = email.toLowerCase();
        
        var emailParts = this.splitEmail(email);

        if (secondLevelDomains && topLevelDomains) {
            // If the email is a valid 2nd-level + top-level, do not suggest anything.
            if (secondLevelDomains.indexOf(emailParts.secondLevelDomain) !== -1 && topLevelDomains.indexOf(emailParts.topLevelDomain) !== -1) {
                return false;
            }
        }

        var closestDomain = this.findClosestDomain(emailParts.domain, domains, distanceFunction, this.domainThreshold);

        if (closestDomain) {
            if (closestDomain == emailParts.domain) {
                // The email address exactly matches one of the supplied domains; do not return a suggestion.
                return false;
            } else {
                // The email address closely matches one of the supplied domains; return a suggestion
                return { address: emailParts.address, domain: closestDomain, full: emailParts.address + "@" + closestDomain };
            }
        }

        // The email address does not closely match one of the supplied domains
        var closestSecondLevelDomain = this.findClosestDomain(emailParts.secondLevelDomain, secondLevelDomains, distanceFunction, this.secondLevelThreshold);
        var closestTopLevelDomain = this.findClosestDomain(emailParts.topLevelDomain, topLevelDomains, distanceFunction, this.topLevelThreshold);

        if (emailParts.domain) {
            closestDomain = emailParts.domain;
            var rtrn = false;

            if (closestSecondLevelDomain && closestSecondLevelDomain != emailParts.secondLevelDomain) {
                // The email address may have a mispelled second-level domain; return a suggestion
                closestDomain = closestDomain.replace(emailParts.secondLevelDomain, closestSecondLevelDomain);
                rtrn = true;
            }

            if (closestTopLevelDomain && closestTopLevelDomain != emailParts.topLevelDomain && emailParts.secondLevelDomain !== '') {
                // The email address may have a mispelled top-level domain; return a suggestion
                closestDomain = closestDomain.replace(new RegExp(emailParts.topLevelDomain + "$"), closestTopLevelDomain);
                rtrn = true;
            }

            if (rtrn) {
                return { address: emailParts.address, domain: closestDomain, full: emailParts.address + "@" + closestDomain };
            }
        }

        /* The email address exactly matches one of the supplied domains, does not closely
         * match any domain and does not appear to simply have a mispelled top-level domain,
         * or is an invalid email address; do not return a suggestion.
         */
        return false;
    }

    findClosestDomain(domain, domains, distanceFunction, threshold) : any{
        threshold = threshold || this.topLevelThreshold;
        var dist;
        var minDist = Infinity;
        var closestDomain = null;

        if (!domain || !domains) {
            return false;
        }
        if (!distanceFunction) {
            distanceFunction = this.sift4Distance;
        }
        
        for (var i = 0; i < domains.length; i++) {
            if (domain === domains[i]) {
                return domain;
            }
            dist = distanceFunction(domain, domains[i]);
            if (dist < minDist) {
                minDist = dist;
                closestDomain = domains[i];
            }
        }

        if (minDist <= threshold && closestDomain !== null) {
            return closestDomain;
        } else {
            return false;
        }
    }
    sift4Distance(s1, s2, maxOffset) : any{
        if (maxOffset === undefined) {
            maxOffset = 5; //default
        }

        if (!s1 || !s1.length) {
            if (!s2) {
                return 0;
            }
            return s2.length;
        }

        if (!s2 || !s2.length) {
            return s1.length;
        }

        var l1 = s1.length;
        var l2 = s2.length;

        var c1 = 0;  //cursor for string 1
        var c2 = 0;  //cursor for string 2
        var lcss = 0;  //largest common subsequence
        var local_cs = 0; //local common substring
        var trans = 0;  //number of transpositions ('ab' vs 'ba')
        var offset_arr = [];  //offset pair array, for computing the transpositions

        while ((c1 < l1) && (c2 < l2)) {
            if (s1.charAt(c1) == s2.charAt(c2)) {
                local_cs++;
                var isTrans = false;
                //see if current match is a transposition
                var i = 0;
                while (i < offset_arr.length) {
                    var ofs = offset_arr[i];
                    if (c1 <= ofs.c1 || c2 <= ofs.c2) {
                        // when two matches cross, the one considered a transposition is the one with the largest difference in offsets
                        isTrans = Math.abs(c2 - c1) >= Math.abs(ofs.c2 - ofs.c1);
                        if (isTrans) {
                            trans++;
                        } else {
                            if (!ofs.trans) {
                                ofs.trans = true;
                                trans++;
                            }
                        }
                        break;
                    } else {
                        if (c1 > ofs.c2 && c2 > ofs.c1) {
                            offset_arr.splice(i, 1);
                        } else {
                            i++;
                        }
                    }
                }
                offset_arr.push({
                    c1: c1,
                    c2: c2,
                    trans: isTrans
                });
            } else {
                lcss += local_cs;
                local_cs = 0;
                if (c1 != c2) {
                    c1 = c2 = Math.min(c1, c2);  //using min allows the computation of transpositions
                }
                //if matching characters are found, remove 1 from both cursors (they get incremented at the end of the loop)
                //so that we can have only one code block handling matches 
                for (var j = 0; j < maxOffset && (c1 + j < l1 || c2 + j < l2); j++) {
                    if ((c1 + j < l1) && (s1.charAt(c1 + j) == s2.charAt(c2))) {
                        c1 += j - 1;
                        c2--;
                        break;
                    }
                    if ((c2 + j < l2) && (s1.charAt(c1) == s2.charAt(c2 + j))) {
                        c1--;
                        c2 += j - 1;
                        break;
                    }
                }
            }
            c1++;
            c2++;
            // this covers the case where the last match is on the last token in list, so that it can compute transpositions correctly
            if ((c1 >= l1) || (c2 >= l2)) {
                lcss += local_cs;
                local_cs = 0;
                c1 = c2 = Math.min(c1, c2);
            }
        }
        lcss += local_cs;
        return Math.round(Math.max(l1, l2) - lcss + trans); //add the cost of transpositions to the final result
    }

}

